/* unplugin-vue-components disabled */import { render } from "./footerNav.vue?vue&type=template&id=c7c7558c&scoped=true"
import script from "./footerNav.vue?vue&type=script&lang=js"
export * from "./footerNav.vue?vue&type=script&lang=js"

import "./footerNav.vue?vue&type=style&index=0&id=c7c7558c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c7558c"]])

export default __exports__